export default {
      id: "flex-alignItems-flex-end-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignItems-flex-end-usage",
      toString: function () {
        return this.url;
      }
    }